import { render, staticRenderFns } from "./Jdr.vue?vue&type=template&id=58c20dea&scoped=true"
import script from "./Jdr.vue?vue&type=script&lang=ts"
export * from "./Jdr.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c20dea",
  null
  
)

export default component.exports